module.exports = __webpack_public_path__ + "static/media/9-iveco.3ed4a091.jpg";